import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import FaceOutlinedIcon from "@mui/icons-material/FaceOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useAssistance } from "../../../hooks/useAssistance";

const AssistanceSettings: React.FC = () => {
  const theme = useTheme();
  const { assistanceMode, setAssistanceMode, assistanceOptions } =
    useAssistance();

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* Title */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: 4,
          pb: 8,
          width: "100%",
          maxWidth: 800,
          margin: "auto",
          position: "relative",
        }}
      >
        <FaceOutlinedIcon sx={{ fontSize: 72, mb: 4, color: "primary.main" }} />
        <Typography
          variant="h5"
          color="textPrimary"
          sx={{
            position: "relative",
            textAlign: "center",
            mb: 1,
            zIndex: 1,
            fontWeight: 600,
          }}
        >
          ตั้งค่าบทบาทผู้ช่วย
        </Typography>
        <Typography
          variant="body1"
          color="textSecondary"
          sx={{ position: "relative", textAlign: "center", mb: 1, zIndex: 1 }}
        >
          เลือกบทบาทและลักษณะของผู้ช่วยของคุณ
        </Typography>
      </Box>

      {/* Information */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          padding: 2,
          borderRadius: 2,
          width: "100%",
          maxWidth: 800,
          mb: 4,
          gap: 2,
          background:
            "linear-gradient(135deg, rgba(168, 192, 255, 0.16), rgba(252, 194, 215, 0.16))",
        }}
      >
        <InfoOutlinedIcon sx={{ fontSize: 16, color: "text.primary" }} />
        <Typography variant="body2" color="textPrimary">
          ผู้ใช้งานสามารถปรับแต่งบทบาทของผู้ช่วยให้เหมาะสมกับการใช้งาน
        </Typography>
      </Box>

      {/* Assistance Settings */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          padding: 2,
          borderRadius: 2,
          width: "100%",
          maxWidth: 800,
          border: "1px solid",
          borderColor: "divider",
          mb: 4,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
          }}
        >
          <FaceOutlinedIcon
            sx={{ fontSize: 32, color: "primary.main", mr: 2 }}
          />
          <Box flexGrow={1}>
            <Typography
              variant="body1"
              color="textPrimary"
              sx={{ fontWeight: 600, mb: 0.5 }}
            >
              ตั้งค่าบทบาท
            </Typography>
            <Typography variant="body2" color="textSecondary">
              การปรับแต่งบทบาทของผู้ช่วยจะมีผลต่อลักษณะการตอบคำถาม
              และรูปแบบการแสดงตัวตน
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            ml: 6,
            mt: 2,
            gap: 2,
            width: `calc(100% - 48px)`,
            "@media (max-width:600px)": { flexDirection: "column" },
          }}
        >
          {assistanceOptions.map((option) => (
            <Button
              key={option.type}
              variant="outlined"
              onClick={() => setAssistanceMode(option.type)}
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: 1,
                width: 160,
                color:
                  option.type !== assistanceMode
                    ? "text.primary"
                    : "primary.main",
                borderColor:
                  option.type !== assistanceMode ? "divider" : "primary.main",
                "@media (max-width:600px)": {
                  width: "100%",
                },
              }}
            >
              {option.icon}
              {option.title}
            </Button>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default AssistanceSettings;
